export default __webpack_public_path__ + "static/media/main-bar-group@2x.dbf2ab36.png";